import { render, staticRenderFns } from "./PostalCode.vue?vue&type=template&id=82f44014&scoped=true"
import script from "./PostalCode.vue?vue&type=script&lang=js"
export * from "./PostalCode.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "82f44014",
  null
  
)

export default component.exports